export default __webpack_public_path__ + "static/media/01_Kom_Umweltbank.29a61130.jpg";